<div class="h-full w-full flex flex-col overflow-y-auto scrollbar-transparent">
    <div class="space-y-8">
        <div>
            <h2 class="text-base/7 font-semibold text-primary">Screening Requirements</h2>
            <p class="text-sm/6 text-secondary">Please provide the detailed requirements for your screening brief.</p>

            <div class="mt-6 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 px-2">

                <div class="sm:col-span-full">
                    <label for="comment" class="block text-sm/6 font-medium text-primary">
                        How would you like to provide the brief requirements?
                    </label>

                    <ul role="list" class="mt-3 grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6">
                        @for (type of briefProvisionOptions; track type.id) {
                        <li class="col-span-1 flex rounded-md" (click)="selectedBriefProvision.set(type)"
                            [class]="selectedBriefProvision()?.id === type.id ? 'border-primary' : 'border-zinc-500'">
                            <div
                                class="flex w-16 shrink-0 items-center justify-center text-sm font-medium rounded-l-md border-t border-l border-b border-zinc-300 dark:border-white/10 text-secondary">
                                @switch (type.id) {
                                @case (1) {
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-8">
                                    <path d="M12 3v12" />
                                    <path d="m17 8-5-5-5 5" />
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                </svg>
                                }
                                @case (2) {
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-8">
                                    <path
                                        d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
                                    <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                                    <path d="M10 9H8" />
                                    <path d="M16 13H8" />
                                    <path d="M16 17H8" />
                                </svg>
                                }
                                }
                            </div>

                            <div
                                class="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-zinc-300 dark:border-white/10">
                                <div class="flex-1 truncate px-4 py-2 text-sm">
                                    <a class="font-medium text-primary hover:text-gray-200">{{ type.name
                                        }}</a>
                                    <p class="text-secondary truncate">{{ type.description }}</p>
                                </div>
                                <div class="shrink-0 pr-2 flex items-center justify-center text-primary">
                                    @if (selectedBriefProvision()?.id === type.id) {
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-6">
                                        <circle cx="12" cy="12" r="10" />
                                        <path d="m9 12 2 2 4-4" />
                                    </svg>
                                    }
                                </div>
                            </div>

                        </li>
                        }
                    </ul>
                </div>

                @if (selectedBriefProvision()?.id === 1) {
                <div class="sm:col-span-full">
                    <label for="comment" class="block text-sm/6 font-medium text-primary">
                        Upload Brief Document
                    </label>

                    <div class="mt-3 w-full overflow-hidden">
                        <atom-add-document (documentUploaded)="onDocumentUploaded($event)"></atom-add-document>
                    </div>


                    <div class="w-full mt-6">
                        <label for="first-name" class="block text-sm/6 font-medium text-primary">Or paste a Google Doc
                            URL</label>
                        <div class="mt-2">
                            <input [formField]="createScreeningService.requirementsForm.requirementsGoogleDocUrl"
                                id="brief-title" type="text"
                                placeholder="https://docs.google.com/document/d/1234567890/edit"
                                class="input-primary text-primary" />
                            <p class="text-secondary text-xs mt-1">Make sure your Google Doc is publicly accessible or
                                shared with view permissions.</p>
                        </div>
                    </div>

                </div>
                }


                @if (selectedBriefProvision()?.id === 2) {
                <div class="sm:col-span-full">
                    <label for="comment" class="block text-sm/6 font-medium text-primary">
                        Screening Requirements
                        <p class="text-xs text-secondary">Describe what you would like to see in the content on each
                            creator's social channel</p>
                    </label>
                    <div class="mt-2">
                        <atom-wysiswyg (htmlContentChange)="onHtmlContentChange($event, 'requirements')"
                            [placeholder]="'Describe your content requirements, including what you want to see and what to avoid...'"></atom-wysiswyg>
                    </div>
                </div>
                <!-- 
                <div class="sm:col-span-full">
                    <label for="comment" class="block text-sm/6 font-medium text-primary">
                        Screening Restrictions
                        <p class="text-xs text-secondary">Describe the deal breakers. If we find any of these items we'll flag the content and account for review. We will pencil these content items as a "Has Issues".</p>
                    </label>
                    <div class="mt-2">
                        <atom-wysiswyg (htmlContentChange)="onHtmlContentChange($event, 'restrictions')"
                            [placeholder]="'Describe your content requirements, including what you want to see and what to avoid...'"></atom-wysiswyg>
                    </div>
                </div> -->
                }


                <div class="sm:col-span-full">
                    <label for="first-name" class="block text-sm/6 font-medium text-primary">Screen Content
                        Until</label>
                    <p class="text-xs text-secondary">SHOUT will evaluate all content on each screened account as far
                        back in time as the selected date.</p>
                    <mat-form-field class="w-full event-date-field mt-2">
                        <input matInput [matDatepicker]="picker" [max]="today" class="event-date-input text-primary">
                        <mat-hint class="text-secondary">MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker [dateClass]="dateClass" #picker [startAt]="today"
                            (selectedChange)="onDateChange($event)"></mat-datepicker>
                    </mat-form-field>
                </div>


            </div>
        </div>
    </div>
</div>